import { Box, CircularProgress, Typography } from "@mui/material";
import ArticleCard from "@/src/components/common/Search/ArticleCard";
import { Pagination } from "@/src/components/common/Pagination";
import {
  FONT_DISPLAY,
  FONT_TEXT,
  hairline,
  HEADING_SIZE,
} from "@/src/components/common/broadsheet/tokens";

const SearchResults = ({
  paginatedArticles,
  selectedArticles,
  setSelectedArticles,
  totalPages,
  currentPage,
  setCurrentPage,
  loading,
}: {
  paginatedArticles: any;
  selectedArticles: any;
  setSelectedArticles: any;
  totalPages: number;
  currentPage: number;
  setCurrentPage: any;
  loading: boolean;
}) => {
  const handleSelectToggle = (doi: string) => {
    setSelectedArticles((prev: any) =>
      prev.includes(doi)
        ? prev.filter((d: string) => d !== doi)
        : [...prev, doi],
    );
  };

  if (loading) {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          minHeight: 200,
          py: 3,
        }}
      >
        <CircularProgress size={28} />
      </Box>
    );
  }

  return (
    <Box>
      {paginatedArticles.length > 0 ? (
        <Box>
          {paginatedArticles.map((article: any) => (
            <ArticleCard
              key={article.id}
              article={article}
              isSelected={selectedArticles.includes(article.doi)}
              onSelectToggle={handleSelectToggle}
            />
          ))}
        </Box>
      ) : (
        <Box
          sx={{
            py: { xs: 3, md: 5 },
            textAlign: "center",
            ...hairline,
          }}
        >
          <Typography
            component="p"
            sx={{
              m: 0,
              fontFamily: FONT_DISPLAY,
              fontWeight: 700,
              fontSize: HEADING_SIZE.section,
              color: "custom.ink",
            }}
          >
            Nothing in the archive matches
          </Typography>
          <Typography
            component="p"
            sx={{
              m: 0,
              mt: 0.25,
              fontFamily: FONT_TEXT,
              fontSize: "0.9375rem",
              color: "custom.inkMuted",
            }}
          >
            Broaden the query, or widen which parts of the article are searched.
          </Typography>
        </Box>
      )}
      {totalPages > 1 && (
        <Box sx={{ display: "flex", justifyContent: "center", pt: 1.25 }}>
          <Pagination
            totalPages={totalPages}
            currentPage={currentPage}
            onPageChange={(page: number) => setCurrentPage(page)}
            color="primary"
          />
        </Box>
      )}
    </Box>
  );
};

export default SearchResults;
